import * as actionTypes from '../constants/customNavContainerConstants';

export const customNavContainerReducer = (state = { containers: [] }, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CONTAINERS_REQUEST:
      return {
        loading: true,
        containers: []
      };
    case actionTypes.FETCH_CONTAINERS_SUCCESS:
      return {
        ...state,
        loading: false,
        containers: action.payload,
      };
    case actionTypes.FETCH_CONTAINERS_FAILURE:
      return {
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
};